import { Autocomplete, TextField, Typography } from "@mui/material";

import { useField } from "formik";
import { useRef, useState } from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 240,
    },
  },
};

export const MultiSelectFormControl = ({
  id,
  label,
  options,
  value,
  handleSubmit,
  getOptionLabel,
  getOptionValue,
  displayField = "displayName", // Control which field to display: "value" or "displayName"
}: any) => {
  const [field, meta, helpers] = useField(id);
  const [open, setOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  // Handle both string arrays and object arrays
  const isObjectOptions = options.length > 0 && typeof options[0] === "object";

  const defaultGetOptionLabel = (option: any) => {
    if (typeof option === "string") return option;
    // Use displayField prop to control which field to show
    if (getOptionLabel) return getOptionLabel(option);
    return option[displayField] || option.displayName || option;
  };

  const defaultGetOptionValue = (option: any) => {
    if (typeof option === "string") return option;
    return getOptionValue ? getOptionValue(option) : option.value || option;
  };

  // For object options, need to match values to options
  const selectedOptions = isObjectOptions
    ? options.filter((opt: any) => value.includes(defaultGetOptionValue(opt)))
    : value;

  const displayText = isObjectOptions
    ? selectedOptions.map((opt: any) => defaultGetOptionLabel(opt)).join(",")
    : value.join(",");

  return (
    <Autocomplete
      id={id}
      multiple
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      size="small"
      sx={{
        width: "256px",
        "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
          {
            paddingRight: 0,
          },
      }}
      getOptionLabel={defaultGetOptionLabel}
      isOptionEqualToValue={(option, value) => {
        return defaultGetOptionValue(option) === defaultGetOptionValue(value);
      }}
      onChange={(_, newValue) => {
        const valuesToStore = isObjectOptions
          ? newValue.map((item: any) => defaultGetOptionValue(item))
          : newValue;
        helpers.setValue(valuesToStore || []);
        handleSubmit();
      }}
      renderTags={(selected, getTagProps) => (
        <Typography
          onClick={() => {
            setOpen(true);
            inputRef.current?.focus();
          }}
          component="div"
          variant="body1"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "200px",
            maxWidth: "calc(100% - 50px)",
            cursor: "pointer",
          }}
        >
          {displayText}
        </Typography>
      )}
      options={options}
      value={selectedOptions}
      renderInput={(params) => (
        <TextField {...params} inputRef={inputRef} label={label} />
      )}
    />
  );
};
